import { render, staticRenderFns } from "./DispensaryProductCreateBasic.vue?vue&type=template&id=5aa96818&scoped=true&"
import script from "./DispensaryProductCreateBasic.vue?vue&type=script&lang=js&"
export * from "./DispensaryProductCreateBasic.vue?vue&type=script&lang=js&"
import style0 from "./DispensaryProductCreateBasic.vue?vue&type=style&index=0&id=5aa96818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa96818",
  null
  
)

export default component.exports